export default function Privacy() {
    return (
        <div style={{ whiteSpace: "pre-wrap", padding: "10px" }}>
{`보이스파크 개인정보 처리방침

제1조(목적)

픽셀소프트웨어(이하 "회사") 의 파크골프 통합 플랫폼 서비스인 보이스파크 (이하 "서비스")는 이용자에게 원활한 파크골프 이용 서비스를 제공하기 위해 개인정보를 처리합니다. 본 개인정보처리방침은 이용자의 개인정보 보호와 관련하여 수집되는 정보의 내용 및 이용 방법을 알려드립니다.

제2조(수집하는 개인정보 항목)

사용자가 서비스에 가입하거나 서비스를 이용할 때, 서비스는 다음과 같은 개인 정보를 수집할 수 있습니다.
필수 입력 항목: 이름, 휴대전화번호, 생년월일, 성별, 본인인증 CI값
※ 본인인증은 나이스평가정보(주)의 본인확인 서비스를 통해 이루어집니다.
선택 사항: 선호 지역, 스코어

제3조(개인정보의 수집 및 이용 목적)
서비스는 수집한 개인정보를 다음의 목적을 위해 이용합니다.

1. 사용자 인증 및 등록 절차의 원활한 진행
2. 서비스 제공 및 관리(스코어, 공인 핸디 관리, 예약, 대회 접수 및 참가자 식별)
3. 서비스 개선 및 조사 분석 (사용자 경험 개선을 위한 통계 및 분석)
4. 고객 지원 및 서비스 관련 문의에 대한 응답
5. 법적 의무 준수(법률 등에 따른 요청)

제4조(개인정보의 보유 및 이용기간)
서비스는 개인정보 수집 목적이 달성될 때까지 개인정보를 보유하며, 이용자가 계정을 삭제하거나 서비스에서 탈퇴하는 경우 해당 정보를 즉시 파기합니다. 단, 법률에 따라 일정 기간 동안 정보를 보존해야 하는 경우에는 관련 법령에 따라 보존합니다.

제5조 (개인정보의 제3자 제공)
본 서비스는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외적으로 제공할 수 있습니다.

1. 이용자가 사전에 동의한 경우
2. 법률에 의한 요청이 있는 경우
3. 본인확인을 위하여 나이스평가정보(주)에 개인정보를 제공하는 경우
   - 제공 항목: 이름, 생년월일, 성별, 휴대전화번호, CI/DI
   - 제공 목적: 본인확인
   - 보유 및 이용기간: 본인확인 완료 후 즉시 폐기 (단, 관련 법령에 따라 일정 기간 보관될 수 
있음)

제6조(개인정보의 안전성 확보 조치)

본 서비스는 개인정보를 보호하기 위해 다음과 같은 보안 조치를 취하고 있습니다.
1. 개인정보의 저장 및 전송 암호화
2. 개인정보 접근권한 관리
3. 정기적인 보안 점검 및 취약점 관리

제7조(이용자의 권리)

1. 개인정보 접근: 이용자는 언제든지 자신의 개인정보에 접근할 수 있습니다.
2. 개인정보의 수정 및 삭제: 이용자는 자신의 개인정보를 수정하거나 삭제할 수 있습니다.
3. 이용 동의 철회: 이용자는 언제든지 서비스 이용 동의를 철회할 수 있습니다. 이 경우 서비스 제공이 제한될 수 있습니다.

제8조(개인정보처리방침의 변경)

본 서비스는 개인정보 처리방침을 변경할 수 있으며, 변경 사항은 서비스 내 공지사항을 통해 고지됩니다. 변경 사항은 공지일로부터 적용됩니다.

제9조(개인정보관리책임자)

개인정보와 관련하여 또는 제품과 관련하여 불만이나 의견이 있으신 분은 회사의 고객창구인 보이스파크 고객센터로 전화(02-523-5175) 주시거나 혹은 아래 개인정보보호책임자 또는 개인정보보호담당부서에게 의견을 주시면 즉시 조치하고 처리 결과를 통보해 드리겠습니다.

1) 개인정보보호책임자

- 성명 : 이충희
- 소속 : 픽셀소프트웨어
- 전화 : 02-523-5177
- 이메일 : dreamjr@fixelsoft.com

이용자는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자 또는 회사에 신고하실 수 있습니다. 
회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다. 
기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.

2) 기타 기관
개인정보침해신고센터 ( privacy.kisa.or.kr / 국번없이 118)
대검찰청 과학수사부 사이버수사과 ( cybercid.spo.go.kr / 국번없이 1301)
경찰청 사이버안전지킴이 ( www.police.go.kr/www/security/cyber.jsp / 국번없이 182)

개인정보에 대한 동의
이용자는 서비스 이용 시 본 개인정보 처리방침에 명시된 사항에 동의함으로써 서비스가 개인정보를 수집, 이용 및 보관하는 것에 동의하는 것으로 간주합니다. 개인정보는 본 방침에 명시된 목적 이외의 용도로 이용되지 않으며, 이용자의 명시적인 동의 없이는 제3자에게 제공하지 않습니다.

동의 철회
이용자는 언제든지 제공된 개인정보 또는 사진 이용에 대한 동의를 철회할 수 있으며, 서비스 내 설정을 통해 개인정보 수정 또는 삭제를 요청할 수 있습니다. 동의를 철회할 경우 일부 서비스 이용에 제한이 있을 수 있습니다.

추가 조항
본 개인정보처리방침은 2025년 8월 25일부터 시행됩니다.`}
</div>
    );
}